export default __webpack_public_path__ + "static/media/icon-fully-customizable.a1532a74.svg";